var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.979,
    height: 23.641,
    viewBox: "0 0 21.979 23.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#393e47;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.41,11.837,21.628,3a1.338,1.338,0,0,0,.351-.914,1.334,1.334,0,0,0-.351-.914l-.72-.774a1.146,1.146,0,0,0-1.7,0L10.99,9.233,2.772.394a1.145,1.145,0,0,0-1.7,0l-.72.774A1.364,1.364,0,0,0,.352,3l8.218,8.84L.352,20.676a1.367,1.367,0,0,0,0,1.829l.72.774a1.145,1.145,0,0,0,1.7,0l8.218-8.84,8.218,8.84a1.152,1.152,0,0,0,.85.378h0a1.152,1.152,0,0,0,.85-.378l.72-.774a1.367,1.367,0,0,0,0-1.829Z",
    transform: "translate(0 -0.016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b0fd57026ff9561fb4222a434774d5ee.svg";
export { ForwardRef as ReactComponent };